import { GridCellProps } from '@progress/kendo-react-grid';

type Props = {
    className?: string;
    e: GridCellProps;
    onClick?: (e) => void;
    amount?: string;
};

const AmountCell = ({ className, e, onClick, amount }: Props) => {
    const data = e?.dataItem;
    return (
        <td className={className ?? ''}>
            <div>{data?.grade?.name ? data?.grade?.name : amount ? amount : ""}</div>
        </td>
    );
};

export default AmountCell;
